export default "__VITE_ASSET__oq7j5Gsx__"